import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem, MDBAlert } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import p4 from '../img/1656587766_35-illustration_png.png'
import Iframe from 'react-iframe'
import {isMobile, browserName, osName, OsTypes } from 'react-device-detect';

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Nursedurablearticles extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

      device:'',
      osName:'',
      browsername:'',
      datelogin:'',
      timelogin:'',
      sizem:'',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.refreshPage = this.refreshPage.bind(this);

  }

  refreshPage() {
    window.location.reload(false);
  }
  

  componentDidMount() {
    if (isMobile) {
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD');
      const formattedtime =moment(now).format('HH:mm');
     // return <div> This content is available only on mobile</div>
      console.log('mobile')
      console.log(browserName)
      console.log(osName)
      console.log(formattedDate)

    
     this.setState({
      device: 'mobile',
      sizem:'250',
      browsername: browserName,
      datelogin : formattedDate,
      timelogin : formattedtime,
      osName : osName,
    });

    }else{
 
      console.log('browser')
      console.log(browserName)
      console.log(osName)
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD HH:mm:ss');
      const formattedtime =moment(now).format('HH:mm');

      console.log(formattedDate)

      this.setState({
        device: 'browser',
        sizem:'800',
        browsername: browserName,
        datelogin : formattedDate,
        timelogin : formattedtime,
        osName : osName,
      });
       
    }
  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
        this.setState({ datastuKamphaengphet: res })
    })

  }


  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }




  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
   console.log(this.state.datastuKamphaengphet)
 //console.log('dd')
    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }
    const sss = this.state.sizem


    return (

      <>
       
       <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />  จำนวนครุภัณฑ์ คณะพยาบาลศาสตร์
                </MDBTypography>
                    {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                    <MDBBreadcrumb>
                        <MDBBreadcrumbItem>ระบบสารสนเทศเพื่อการตัดสินใจด้านการบริหาร</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>จำนวนครุภัณฑ์ </MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                    <div className='text-right'> <a href='/welcome'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a>
                    {/* <MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn> */}
                    </div>
                         
                            <Iframe url="https://lookerstudio.google.com/embed/reporting/0f063150-5163-45c9-b5c3-1c01cb433765/page/VdGsD"
                                 width="100%"
                                 height={sss}
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/>

              </MDBJumbotron>

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </>


    )
  }
}
